import { useLayoutEffect, useRef } from 'react'

const TRANSITION_CLASS = 'palette-transition'
const TRANSITION_WINDOW_MS = 600

/**
 * Fades themed colors when the cinematic palette swaps mid-session (branding
 * merge) instead of snapping: tags <html> with .palette-transition (see
 * globals.scss) for the frame the new CSS variables paint. Layout effect so
 * the class is in place before paint; skips the initial mount.
 */
export function usePaletteTransition(colorStyles: string) {
  const prevColorStyles = useRef<string | null>(null)

  useLayoutEffect(() => {
    const prev = prevColorStyles.current
    prevColorStyles.current = colorStyles
    if (prev === null || prev === colorStyles) return

    const root = document.documentElement
    root.classList.add(TRANSITION_CLASS)
    const timer = setTimeout(() => root.classList.remove(TRANSITION_CLASS), TRANSITION_WINDOW_MS)
    return () => {
      clearTimeout(timer)
      root.classList.remove(TRANSITION_CLASS)
    }
  }, [colorStyles])
}
